export default __webpack_public_path__ + "static/media/GR00063-owl_suparat.c501b378.svg";